import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=c3a2cef2&scoped=true&"
import script from "./answer.vue?vue&type=script&lang=js&"
export * from "./answer.vue?vue&type=script&lang=js&"
import style0 from "./answer.vue?vue&type=style&index=0&id=c3a2cef2&lang=less&scoped=true&"
import style1 from "./answer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a2cef2",
  null
  
)

export default component.exports